<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Customer Roster</div>

    <div class="divider"></div>
    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input matInput type="text" [formControl]="searchValueControl" />
      </mat-form-field>
    </div>
    <div class="divider"></div>
    <div class="filter">
      <button mat-button class="icon-btn" (click)="openSearchDialog()" matTooltip="Search & filters" aria-label="Search & filters">
        <svg-icon
          src="assets/svg/filter.svg"
          [svgClass]="filterOpen ? 'lightGreen' : 'grey'"
        ></svg-icon>
      </button>
    </div>
    <div class="divider" *ngIf="showResetSearch"></div>
    <div class="filter" *ngIf="showResetSearch">
      <button mat-button color="fiord" (click)="resetSearchV2()" [disabled]="filterOpen" matTooltip="Reset search" aria-label="Reset search">
        Reset Search
      </button>
    </div>
    <div class="divider"></div>
    <button
      mat-button
      class="icon-btn"
      [matMenuTriggerFor]="columnMenu"
      [disabled]="filterOpen"
      matTooltip="Choose columns"
      aria-label="Choose columns"
    >
      <svg-icon src="assets/svg/fields.svg"></svg-icon>
    </button>

    <mat-menu
      class="mat-menu-elaphant vertical-menu column-menu"
      #columnMenu="matMenu"
    >
      <div class="column-actions" style="padding: 8px; margin-top: -8px; border-bottom: 1px solid rgba(255,255,255,0.1);">
        <button mat-button color="fiord" (click)="resetColumnsToDefault(); $event.stopPropagation()">Reset to Defaults</button>
      </div>
      <div class="column-options" style="padding-top: 8px;">
        <div style="padding: 4px 0; font-weight: 600; opacity: 0.9;">Device</div>
        <mat-checkbox
          *ngFor="let column of deviceColumns"
          [checked]="column.selected"
          color="lightGreen"
          (click)="$event.stopPropagation()"
          (change)="onColumnSelectionChange($event, column)"
          >{{ column.name }}</mat-checkbox
        >
        <div style="height: 8px;"></div>
        <div style="border-top: 1px solid rgba(255,255,255,0.1);"></div>
        <div style="height: 8px;"></div>
        <div style="padding: 4px 0; font-weight: 600; opacity: 0.9;">Standard</div>
        <mat-checkbox
          *ngFor="let column of standardColumns"
          [checked]="column.selected"
          color="lightGreen"
          (click)="$event.stopPropagation()"
          (change)="onColumnSelectionChange($event, column)"
          >{{ column.name }}</mat-checkbox
        >
        <ng-container *ngIf="customColumns.length > 0">
          <div style="height: 8px;"></div>
          <div style="border-top: 1px solid rgba(255,255,255,0.1);"></div>
          <div style="height: 8px;"></div>
          <div style="padding: 4px 0; font-weight: 600; opacity: 0.9;">Custom</div>
          <mat-checkbox
            *ngFor="let column of customColumns"
            [checked]="column.selected"
            color="lightGreen"
            (click)="$event.stopPropagation()"
            (change)="onColumnSelectionChange($event, column)"
            >{{ column.name }}</mat-checkbox
          >
        </ng-container>
      </div>
    </mat-menu>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <ng-container *ngIf="!filterOpen && (paginator?.length || 0) > 0">
      <button
        mat-icon-button
        [matMenuTriggerFor]="downloadMenu"
        matTooltip="Download"
        aria-label="Download"
        style="margin-right: 8px;"
      >
      <svg-icon src="assets/svg/download.svg"></svg-icon>
      </button>
      <button
        mat-icon-button
        [routerLink]="['/customers/imports']"
        matTooltip="Customer Imports"
        aria-label="Customer Imports"
        style="margin-right: 8px;"
      >
      <svg-icon src="assets/svg/import-customers.svg"></svg-icon>
      </button>
      <mat-menu class="mat-menu-elaphant" #downloadMenu="matMenu">
        <button class="icon-btn-w-text" mat-menu-item (click)="exportToExcel()">
          <svg-icon src="assets/svg/sheet.svg" svgClass="white"></svg-icon>
          <span>Export to Excel</span>
        </button>
        <button class="icon-btn-w-text" mat-menu-item (click)="exportToCsv()">
          <svg-icon src="assets/svg/sheet.svg" svgClass="white"></svg-icon>
          <span>Export to CSV</span>
        </button>
      </mat-menu>
    </ng-container>
    <ng-container *ngIf="!filterOpen && showSendBroadcastToList">
      <button
        mat-icon-button
        (click)="sendBroadcastToList()"
        matTooltip="Send Broadcast to List"
        aria-label="Send Broadcast to List"
      >
      <svg-icon src="assets/svg/customers-broadcast.svg"></svg-icon>
      </button>
    </ng-container>

    <ng-container *ngIf="filterOpen">
      <button mat-button color="fiord" (click)="resetFilters()" matTooltip="Reset current filters" aria-label="Reset current filters">Reset</button>
      <button
        mat-button
        [disabled]="saveDisabled"
        color="lightGreen"
        (click)="applyFilters()"
        matTooltip="Apply filters"
        aria-label="Apply filters"
      >
        Apply filters
      </button>
    </ng-container>
  </div>
</div>
<div class="roster">
  <div [hidden]="filterOpen" class="container roster-container">
    <div
      class="container-content"
      lhpeElementLoader
      #customersElementLoader="elementloader"
    >
      <table
        #customersTable
        mat-table
        [dataSource]="customersDataSource"
        matSort
      >
        <ng-container *ngFor="let column of displayedColumnsObj">
          <ng-container
            [matColumnDef]="column.id"
          >
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ column.name }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{displayValueForProfileData(column, row)}}
            </td>
          </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          [ngClass]="{ 'clickable-row': showClickableUsers }"
          *matRowDef="let row; columns: displayedColumns"
          (click)="showClickableUsers ? onCustomerSelected(row) : ''"
        ></tr>
      </table>
      <mat-paginator
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="currentPage"
        [pageSize]="perPage"
        (page)="onPageChange($event)"
      ></mat-paginator>
    </div>
  </div>
  <lhpe-audience-container
    [hidden]="!filterOpen"
    [fromCustomer]="true"
    [keyword]="searchValueText"
  ></lhpe-audience-container>
</div>
